import { orderBy as _orderBy } from 'lodash';
import { parseISO } from 'date-fns';

export const orderItemsByUpdatedAt = (items: any) =>
  _orderBy(items, [(item: any) => parseISO(item.updatedAt)], ['desc']);
